export default __webpack_public_path__ + "static/tiempos-text-web-regular-7610ab8d8b4999e3e719a5282b27ba38.woff";